import showToast from "../components/CustomToast/toastHelper";

export const exportToCSV = (data: any, filename :string) => {
    if (!data || !data.length) {
        console.error('No data provided');
        showToast('No data provided', "error")
        return;
    }

    // Extract keys (column headers) from the first object
    const headers = Object.keys(data[0]);
    const csvRows = [];

    // Add headers as the first row
    csvRows.push(headers.join(','));

    // Loop through the data and create a CSV row for each object
    for (const row of data) {
        const values = headers.map(header => {
            const escaped = ('' + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
    }

    // Create a blob with the CSV content
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a link element and trigger the download
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};